import React, { useContext, useEffect, useState } from 'react'
import './index.scss'
import { observer } from 'mobx-react'
import { StoresContext } from '@App/contexts'
import Navigation from '@App/navigation'
import RightsholderContactInformationEdit from '@Components/RightsholderContact/RightsholderContactInformationEdit'
import RightsholderContactInformationView from '@Components/RightsholderContact/RightsholderContactInformationView'
import ModalPortal from '@Components/Popups/ModalPortal'
import Popup from '@Components/Popups/Popup'
import ConfirmationPopup from '@Components/Popups/ConfirmationPopup'
import NakedButton from '@Components/Buttons/NakedButton'
import { useNavigate, useParams } from 'react-router'
import ContentHeader from '@Components/ContentHeader'
import RightsholderContactInformationContentHeader from '@Scenes/RightsholderScene/RightsholderContactInformation/RightsholderContactInformationContentHeader'
import { analyticsSendPage } from '@App/common/utils/analytics-utils'

const RightsholderContactInformation = observer(() => {
    const params = useParams()
    const [isEditable, setIsEditable] = useState<boolean>(false)
    const [isPopupOpen, setIsPopupOpen] = useState<boolean>(false)
    const [isNew, setIsNew] = useState<boolean>(false)

    const navigate = useNavigate()

    const { rightsholderStore, contactStore, popupStore, preloaderStore } = useContext(StoresContext)

    const goBack = () => {
        if (isEditable) {
            setIsPopupOpen(true)
        } else {
            navigate(-1)
        }
    }

    const loadDataFromUrlValues = async () => {
        if (!params.contactId) {
            navigate(
                Navigation.rightholder.maintenance.memberContacts(
                    params.rightsholderId || rightsholderStore.currentRightsholderId
                )
            )
            return
        }
        await contactStore.loadRightsholderContactById(params.contactId).catch((error: any) => {
            popupStore.setAlertData(error.message, true)
            navigate(
                Navigation.rightholder.maintenance.memberContacts(
                    params.rightsholderId || rightsholderStore.currentRightsholderId
                )
            )
        })
    }

    const setData = async () => {
        preloaderStore.openTransparentPreloader(true)
        if (params.contactId === 'new') {
            setIsEditable(true)
            setIsNew(true)
        } else {
            if (!contactStore.rightsholderContact) {
                await loadDataFromUrlValues()
            }
        }
        preloaderStore.openTransparentPreloader(false)
    }

    const setEditable = async (obj: any) => {
        setIsEditable(obj.isEditable)
        setIsNew(obj.isNew)
        await setData()
    }

    const handleCancelCancel = () => {
        setIsPopupOpen(false)
    }

    const confirmedCancelChanges = () => {
        if (isNew) {
            navigate(-1)
        } else {
            setIsEditable(false)
            setIsNew(false)
            setIsPopupOpen(false)
        }
    }

    useEffect(() => {
        analyticsSendPage('rightsholder_contact')
        setData().then()
        return () => contactStore.setRightsholderContact(null)
    }, [])

    if (!contactStore.rightsholderContact && !isNew) {
        return null
    }

    return (
        <>
            <title>Contact Information</title>
            <div className="global-container">
                <div className="rightsholder-contact-information">
                    <div className="head-block">
                        <ContentHeader
                            title="Contact Information"
                            navLeft={<NakedButton onClick={goBack}>&lt; Back</NakedButton>}
                            descriptionElement={<RightsholderContactInformationContentHeader />}
                        />
                    </div>
                    {isEditable ? (
                        <RightsholderContactInformationEdit createRightsholderContact={isNew} goBack={goBack} />
                    ) : (
                        <RightsholderContactInformationView setIsEditableState={setEditable} />
                    )}
                </div>
            </div>
            <ModalPortal isOpen={isPopupOpen} onClose={handleCancelCancel}>
                <Popup onClose={handleCancelCancel}>
                    <ConfirmationPopup
                        title="Are you sure you want to cancel?"
                        onCancel={handleCancelCancel}
                        onConfirm={confirmedCancelChanges}
                        cancelButtonText="Go Back"
                        confirmButtonText="Yes, I want to cancel"
                        confirmButtonClassName="confirm-delete-contact-button"
                    >
                        <p className="sub-text">Clicking cancel will not save any of the changes you may have made.</p>
                    </ConfirmationPopup>
                </Popup>
            </ModalPortal>
        </>
    )
})

export default RightsholderContactInformation
